import React from 'react';
import './Tomorrow.min.css'
import {ReactComponent as SVGIlustration} from '../../nowa_wersja.svg';
import Sun2 from './sun2'

const Tomorrow = props => {
    const {date2, city, sunrise2, sunset2, temp2, tempMin2, tempMax2, tempFeels2, pressure2, wind2, icon,icon2, humidity2, id2, err, } = props.weather
    let content = null;
    let numberId = Number(Object.values({id2}));
    let niebo = {
        200:"Burza z piorunami z lekkim deszczem",
        201:"Burza z piorunami z deszczem",
        202:"Burza z piorunami z ulewnym deszczem",
        210:"Lekka burza z piorunami",
        211:"Burza z piorunami",
        212:"Silna burza z piorunami",
        221:"Burza z piorunami",
        230:"Burza z piorunami z lekką mżawką",
        231:"Burza z piorunami z mżawką",
        232:"Burza z piorunami z ulewną mżawką",
        300:"Lekka mżawka",
        301:"Mżawka",
        302:"Intensywna mżawka",
        310:"Lekki deszcz",
        311:"Deszcz",
        312:"Ulewa",
        313:"Mżawka lub deszcz",
        314:"Intensywna mżawka lub deszcz",
        321:"Deszczowa mżawka",
        500:"Lekki deszcz",
        501:"Umiarkowane opady deszczu",
        502:"Intensywny deszcz",
        503:"Bardzo ulewny deszcz",
        504:"Ekstremalny deszcz",
        511:"Marznący deszcz",
        520:"Lekki deszcz",
        521:"Umiarkowane opady",
        522:"Bardzo ulewny deszcz",
        531:"Deszcz",
        600:"Lekkie opady śniegu",
        601:"Śnieg",
        602:"Duże opady śniegu",
        611:"Śnieg z deszczem",
        612:"Lekki deszcz ze śniegiem",
        613:"Deszcz ze śniegiem",
        615:"Lekki deszcz ze śniegiem",
        616:"Deszcz i śnieg",
        620:"Lekki opady deszczu ze śniegiem",
        621:"Śnieg",
        622:"Duże opady śniegu",
        701:"Mgła",
        711:"Smog",
        721:"Mgła",
        731:"Zamiecie",
        741:"Mgła",
        751:"Burza piaskowa",
        761:"Pył",
        762:"Pył wulkaniczny",
        771:"Szkwał",
        781:"Tornado",
        800:"Czyste niebo",
        801:"Zachmurzenie: 11-25%",
        802:"Zachmurzenie: 25-50%",
        803:"Zachmurzenie: 51-84%",
        804:"Zachmurzenie: 85-100%",
    }
    let descripitonWeather = niebo[numberId];
    
    
    if(!err && city){
        let sunriseTime = new Date(sunrise2 * 1000).toLocaleTimeString();
        let sunsetTime = new Date(sunset2 * 1000).toLocaleTimeString();
        let sunriseTime2 = new Date(sunrise2*1000);
        let sunsetTime2 = new Date(sunset2*1000);
        let differentTime = new Date(sunsetTime2.getTime() - sunriseTime2.getTime());
        let lenghtDay = ((differentTime.getHours()) - 1 + ":" + differentTime.getMinutes() + ":" + differentTime.getSeconds());
      
      
        content = (
            
            <div onLoad={props.function} id='tomorrow'>
               
          
                <p id='date'>{date2}</p>
                <p id='tempFeels'>Odczuwalna: {Math.round (tempFeels2)}&#176;C</p>
                <img src= {"icon_id/" + icon2 + ".png"} id='icon'></img>
                <img src= {"icon_id/" + icon + ".png"} id='visibility'></img>
                <p id='temp'>{Math.round (temp2)}&#176;C</p>
                <p id='tempDay'>Dzień: {Math.round (tempMax2)}&#176;C  &#8593; &#9900; Noc: {Math.round (tempMin2)}&#176;C &#8595;</p>
                <p id='descriptionWeather'>{descripitonWeather}</p>
                <div id='otherConditions'>
                <ul id='one'>
                        <li><p id='pressure'></p> </li>
                        <li><p id='humidity'></p></li>
                        <li><p id='wind'></p> </li>
                    </ul>
                    <ul id='two'>
                        <li><p>{wind2} km/h </p></li>
                        <li><p>{pressure2} hPa </p></li>
                        <li><p>{humidity2} %</p></li>
                    </ul>
                    </div>
    
                <div id='sunAll'> 
                <div id='sunn' >
                    <SVGIlustration/>
                    
                </div>
                    
                    <p id='lenghtDay'>Długość dnia: {lenghtDay}</p>
                    <p id='sunrise'><span>Wschód słonca:</span>  {sunriseTime} </p>
                    <p id='sunset'><span>Zachód słonca:</span> {sunsetTime}</p>
                   
                </div>
                <Sun2 {...props}/>
                   
            </div>
    
        )
    }
    return(
        <div className='tomorrow'>
            
            {err ? `Nie mamy w bazie ${city}` : content}
            
        </div>
        
    )
    
}

export default Tomorrow;